import { AxiosService } from '../../services/axiosService';

export const getSapPriceApi = options => {
  return AxiosService.get('sap-price', { filter: options.filter });
};
